module.exports = "mutation ExportContacts($email: String!, $contacts: [ID!]!) {\n  exportContacts(email: $email, contacts: $contacts) {\n    success\n  }\n}\n"